export default abstract class Model {
  getters: any

  constructor(getters:any) {
    this.getters = getters;
  }
}